<template>
  <el-dialog
    title
    :visible.sync="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1260px"
    custom-class="custom-dialog"
    @closed="init"
  >
    <div slot="title">
      <el-row>
        <h3 style="text-align:center;margin:10px 0;font-size:18px">
          阿尔法职能模块
          <el-tooltip class="item" effect="dark" :append-to-body="true" placement="right">
            <div slot="content" style="width:500px;line-height:1.5;font-size:14px">
              定义职能模块是阿尔法系统特有的智能匹配实现的第一步； <br />可能有点麻烦，但是做一步会节省后期大量时间；
              <br />定义职能模块是把岗位按照工作职责来分类的做法。同类型的工作职责归类为一个职能模块。
              <br />常用的职能模块包括：HR、机构销售、财务、投行、股票投资、股权投资等。
              <br />以下是我们所有已经定义的职能模块，可以直接点击职能模块名称。如果暂时未包含，可以点击新建，感谢您又为我们系统添砖加瓦。新建的职能模块，我们会通知大行业的负责人，他会做审核，是否变成系统常用的职能模块。
            </div>
            <i class="el-icon-question" style="cursor:pointer;display:inline"></i>
          </el-tooltip>
        </h3>
        <!-- <div style="width:80%;margin:0 auto;font-size:14px">
          <p>定义职能模块是阿尔法系统特有的智能匹配实现的第一步；</p>
          <p>可能有点麻烦，但是做一步会节省后期大量时间；</p>
          <p>定义职能模块是把岗位按照工作职责来分类的做法。同类型的工作职责归类为一个职能模块。</p>
          <p>常用的职能模块包括：HR、机构销售、财务、投行、股票投资、股权投资等。</p>
          <p>以下是我们所有已经定义的职能模块，可以直接点击职能模块名称。如果暂时未包含，可以点击新建，感谢您又为我们系统添砖加瓦。新建的职能模块，我们会通知大行业的负责人，他会做审核，是否变成系统常用的职能模块。</p>
        </div>-->
      </el-row>
    </div>
    <el-container>
      <el-header style="border-bottom:1px solid #eee;">
        <el-row type="flex" align="middle">
          <el-col :span="4" style="font-size:16px">请选择职能模块(可多选)</el-col>
          <el-col :span="16">
            <el-autocomplete
              v-model="searchResult"
              :fetch-suggestions="querySearch"
              suffix-icon="el-icon-search"
              placeholder="点击以下行业选择职能模块或者点击右边新增职能模块"
              class="cus-autoc"
              size="mini"
            >
              <template slot-scope="{ item }">
                <div @click="selectResult(item)">
                  <div style="font-size:14px">{{ item }}</div>
                </div>
              </template>
            </el-autocomplete>
          </el-col>
          <el-col :span="4" style="display:flex;justify-content:flex-end">
            <el-button size="mini" type="primary" style="font-size:14px" @click="createFunction"
              >新增职能模块</el-button
            >
          </el-col>
        </el-row>
      </el-header>
      <el-header v-if="selectedFunction.length > 0" height="auto" style="border-bottom:1px solid #eee;padding:20px">
        <el-row class="mb10" :gutter="6">
          <el-col :span="2" style="font-size:16px"> <b>已选择:</b> </el-col>
          <el-col :offset="18" :span="2">
            <el-button type="primary" size="mini" style="width:100%" @click="submitData">确定</el-button>
          </el-col>
          <el-col :span="2"> <el-button size="mini" style="width:100%" @click="cancel">取消</el-button> </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <div v-for="item in selectedFunction" :key="item.名称" style="display:inline-block">
              <el-tag class="mr10 mb10" closable @close="removeFunction(item.名称)">
                职能模块:
                <el-tag
                  closable
                  size="mini"
                  style="cursor:pointer"
                  class="mr10 mb10"
                  effect="plain"
                  @close="removeFunction(item.名称)"
                  >{{ item.名称 }}</el-tag
                >
                <span v-if="item.细分职能 && item.细分职能.length > 0">细分职能:</span>
                <el-tag
                  v-for="item1 in item.细分职能"
                  :key="item1 + '细分职能'"
                  closable
                  size="mini"
                  style="cursor:pointer"
                  class="mr10 mb10"
                  effect="plain"
                  @close="removeSub(item1, '细分职能')"
                  >{{ item1 }}</el-tag
                >
                <span v-if="item.擅长方向 && item.擅长方向.length > 0">擅长方向:</span>
                <el-tag
                  v-for="item1 in item.擅长方向"
                  :key="item1 + '擅长方向'"
                  closable
                  size="mini"
                  style="cursor:pointer"
                  class="mr10 mb10"
                  effect="plain"
                  @close="removeSub(item1, '擅长方向')"
                  >{{ item1 }}</el-tag
                >
              </el-tag>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container class="mb20" style="padding:20px 0">
        <el-aside style="height:48vh;overflow:scroll" width="200px">
          <el-menu :default-active="curIndustries" @select="selectIndustries">
            <el-menu-item v-for="item in industries" :key="item" :index="item" style="height:40px;line-height:40px">
              {{ item }}
              <el-badge v-if="hasIndustries(item)" class="mark" is-dot />
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main style="height:48vh;overflow:scroll">
          <!-- <el-radio-group v-model="pingtai" size="small" class="mb10">
            <el-radio-button label="A">大平台</el-radio-button>
            <el-radio-button label="B">中型平台</el-radio-button>
            <el-radio-button label="C">小平台</el-radio-button>
            <el-radio-button label>未分类公司</el-radio-button>
          </el-radio-group>-->
          <div class="tag-group">
            <div v-for="(row, rowIdx) in tagRow" :key="rowIdx" class="tag-row">
              <div v-for="(item, idx) in row" :key="idx" style="display:inline-block" class="tag-item">
                <i
                  v-if="idx !== currentItemIdx || rowIdx !== currentRowIdx"
                  class="el-icon-circle-plus"
                  style="color: #303133;cursor:pointer"
                  @click="openRow(rowIdx, idx, item)"
                ></i>
                <i
                  v-else
                  class="el-icon-remove"
                  style="color: #303133;cursor:pointer"
                  @click="closeRow(rowIdx, idx)"
                ></i>
                <el-tag
                  size="medium"
                  style="margin-left:5px;cursor:pointer;border:none;font-size:14px;width:180px;display:inline-flex;justify-content:space-between;align-items:center"
                  class="mr10 mb10 custom-tags"
                  :closable="tagType(item) === 'dark'"
                  :effect="tagType(item)"
                  @close="removeFunction(item, rowIdx, idx)"
                  @click="selectFunction(rowIdx, idx, item)"
                  >{{ item }}</el-tag
                >
              </div>
              <el-card v-if="rowIdx === currentRowIdx" style="width:94%;margin:0 auto 10px;background-color:#ddd">
                <el-row style="font-weight:bold">细分职能:</el-row>
                <el-row v-if="currentDetailData.细分职能.length > 0">
                  <el-tag
                    v-for="(item1, idx1) in currentDetailData.细分职能"
                    :key="idx1"
                    style="margin:5px;cursor:pointer;border:none;font-size:14px"
                    class="custom-tags"
                    size="mini"
                    :closable="subTagType(item1, '细分职能') === 'dark'"
                    :effect="subTagType(item1, '细分职能')"
                    @close="removeSub(item1, '细分职能')"
                    @click="selectSub(item1, '细分职能')"
                    >{{ item1 }}</el-tag
                  >
                </el-row>
                <el-row v-else style="color: #666;margin:5px 0 5px 14px">暂无该职能模块的细分职能</el-row>
                <el-row style="font-weight:bold">擅长方向:</el-row>
                <el-row v-if="currentDetailData.擅长方向.length > 0">
                  <el-tag
                    v-for="(item1, idx1) in currentDetailData.擅长方向"
                    :key="idx1"
                    style="margin:5px;cursor:pointer;border:none;font-size:14px"
                    class="custom-tags"
                    size="mini"
                    :closable="subTagType(item1, '擅长方向') === 'dark'"
                    :effect="subTagType(item1, '擅长方向')"
                    @close="removeSub(item1, '擅长方向')"
                    @click="selectSub(item1, '擅长方向')"
                    >{{ item1 }}</el-tag
                  >
                </el-row>
                <el-row v-else style="color: #666;margin:5px 0 5px 14px">暂无该职能模块的擅长方向</el-row>
              </el-card>
            </div>
            <div v-if="resultFunction.length === 0">暂无相关数据~</div>
          </div>
        </el-main>
      </el-container>
      <el-footer height="auto"></el-footer>
    </el-container>
    <createFunction ref="createFunction" @confirmCreate="confirmCreate"></createFunction>
  </el-dialog>
</template>
<script>
import createFunction from './createFunction.vue'

const functionData = [
  {
    行业: '通用',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '证券',
    children: [
      'NS-非标',
      'FT-债券交易',
      'FI-债券开发执行',
      'IBD-投行',
      'RISK-风控',
      'BB-经纪业务',
      'FIR-固收研究',
      'IS-机构销售',
      'ABS-资产证券化',
      'FII-固收投资',
      'OM-运营管理',
      'EQ-股票投资',
      'TD-交易员',
      'HKDCM-香港DCM',
      'HKECM-香港ECM',
      'DCM-债券DCM',
      'ECM-股本ECM',
      'DS-渠道销售',
      'WM-财富管理',
      'FIS-债券销售',
      'COM-合规',
      'KC&QC-内核&质控',
      'RI-研究',
      'PDT-产品',
      'IT-信息技术',
      'FOF-FOF',
      'QDII-海外投资（二级市场）',
      'QUANT-量化投资',
      'FATA-运营',
      'HK-IBD',
      'SR-战略研究',
      '股票质押',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '公募基金',
    children: [
      'IS-机构销售',
      'FOF-FOF',
      'QDII-海外投资（二级市场）',
      'DS-渠道销售',
      'QUANT-量化投资',
      'RI-研究',
      'FATA-运营',
      'FII-固收投资',
      'TD-交易员',
      'FIR-固收研究',
      'PDT-产品',
      'RISK-风控',
      'EQ-股票投资',
      'CF-消费金融',
      'EQS-股票销售',
      'SR-战略研究',
      '股票质押',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '信托',
    children: [
      'NS-非标',
      'IS-机构销售',
      'WM-财富管理',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '信用评级',
    children: [
      'FIR-固收研究',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '保险资管',
    children: [
      'EQ-股票投资',
      'FOF-FOF',
      'DS-渠道销售',
      'FIR-固收研究',
      'IT-信息技术',
      'RI-研究',
      'RISK-风控',
      'IS-机构销售',
      'NS-非标',
      'COM-合规',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '律所',
    children: [
      'LEGAL-律所',
      'Consult-咨询',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '银行',
    children: [
      'IS-机构销售',
      'PS-产品销售',
      'RM-客户经理',
      'MO-中台支持',
      'COM-合规',
      'FT-债券交易',
      'FII-固收投资',
      'FIS-债券销售',
      'RISK-风控',
      'PDT-产品',
      'IT-信息技术',
      'TD-交易员',
      'RI-研究',
      'WM-财富管理',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '保险',
    children: [
      'MO-中台支持',
      'EQ-股票投资',
      'FOF-FOF',
      'FII-固收投资',
      'FIR-固收研究',
      'RM-客户经理',
      'PDT-产品',
      'AMC-不良资产处置',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '金控集团',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '私募股权',
    children: [
      'PM-投后管理',
      'VC-风险投资',
      'SI-战略投资',
      'PEVC-股权投资',
      'FA-融资顾问',
      'REI-地产投资',
      'MF-夹层基金',
      'BF-并购基金',
      'FOF-母基金',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '券商资管',
    children: [
      'AMC-不良资产管理',
      'IS-机构销售',
      'DZ-定向增发',
      'FII-固收投资',
      'RISK-风控',
      'EQ-股票投资',
      'ABS-资产证券化',
      'FI-债券开发执行',
      'FIS-债券销售',
      'TD-交易员',
      'PDT-产品',
      'BB-经纪业务',
      'DS-渠道销售',
      'FATA-运营',
      'RI-研究',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '私募基金',
    children: [
      'QUANT-量化投资',
      'FII-固收投资',
      'IS-机构销售',
      'DS-渠道销售',
      'EQ-股票投资',
      'PDT-产品',
      'RI-研究',
      'IR-投资者关系',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '基金子',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '基金评级',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '会计事务所',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '第三方财富',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '咨询',
    children: [
      'Consult-咨询',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '期货',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '融资租赁',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '互联网金融',
    children: [
      '客户服务',
      '文案编辑',
      'NET-运营',
      '用户研究',
      '交互设计',
      '视觉设计',
      '项目管理',
      '产品',
      '企业软件',
      '硬件开发',
      '互联网运维',
      '测试',
      '移动开发',
      'DBA数据',
      '人工智能',
      '前端开发',
      '后端开发',
      '互联网行业',
      'FINTECH-互联网金融',
      'CF-消费金融',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '互联网',
    children: [
      '客户服务',
      '文案编辑',
      'NET-运营',
      '用户研究',
      '交互设计',
      '视觉设计',
      '项目管理',
      '产品',
      '企业软件',
      '硬件开发',
      '互联网运维',
      '测试',
      '移动开发',
      'DBA数据',
      '人工智能',
      '前端开发',
      '后端开发',
      '互联网行业',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '银行资管',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '银行理财子',
    children: [
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '外资银行',
    children: [
      'COM-合规',
      'RM-客户经理',
      'PDT-产品',
      '客户服务',
      'IT-信息技术',
      'LEGAL-律所',
      'HKDCM-香港DCM',
      'HKECM-香港ECM',
      'MO-中台支持',
      'PS-产品销售',
      'IR-投资者关系',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '外资投行',
    children: [
      'IBD-投行',
      'HK-IBD',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
  {
    行业: '房地产',
    children: [
      '房地产行业',
      '地产行业（数据统计）',
      'Sales&MKT-大市场',
      'RO-香港金融机构持牌人',
      'Headhunter-猎头',
      'SR-战略研究',
      'BD-客户拓展',
      'MKT-市场营销',
      'FIN-财务',
      'HR-人力',
      'PR-公关',
      '运营管理',
      'Admi&Sec-行政文秘',
      'LEGAL&COM-法务合规',
      '高管',
    ],
  },
]
export default {
  components: {
    createFunction,
  },
  filters: {},
  props: {
    single: { type: Boolean, default: false },
  },
  data: function() {
    return {
      dialogVisible: false,
      industries: functionData.map(val => val.行业),
      selectedFunction: [],
      allFunctionData: [],
      searchResult: '',
      curIndustries: '通用',
      resultFunction: [],
      tagRow: [],
      currentRowIdx: -1,
      currentItemIdx: -1,
      currentDetailData: {
        名称: [],
        细分职能: [],
        擅长方向: [],
      },
    }
  },
  watch: {
    curIndustries(val) {
      this.getFunction()
    },
    selectedFunction(val) {},
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.selectedFunction = []
      this.allFunctionData = []
      this.searchResult = ''
      this.curIndustries = '通用'
      this.resultFunction = []
      this.tagRow = []
      this.currentRowIdx = -1
      this.currentItemIdx = -1
      this.currentDetailData = {
        名称: [],
        细分职能: [],
        擅长方向: [],
      }
      this.loadAllFunction()
      this.getFunction()
    },
    createFunction() {
      this.$refs.createFunction.open()
    },
    async confirmCreate(data) {
      await app.getCats()
      this.loadAllFunction()
    },
    selectResult(item) {
      this.single
        ? (this.selectedFunction = [{ 名称: item }])
        : this.selectedFunction.every(val => item !== val) && this.selectedFunction.push({ 名称: item })
      for (let i = 0; i < functionData.length; i++) {
        if (functionData[i].children.includes(item)) {
          this.curIndustries = functionData[i].行业
          break
        }
      }
      this.$nextTick(() => {
        const rowIdx = Math.floor(this.resultFunction.indexOf(item) / 4)
        const itemIdx = this.tagRow.indexOf(item)
        this.openRow(rowIdx, itemIdx, item)
      })
    },
    selectIndustries(item) {
      this.curIndustries = item
      this.closeRow()
    },
    async getFunction() {
      const data = functionData.find(val => val.行业 === this.curIndustries).children
      this.resultFunction = data
      const tagRow = new Array(Math.ceil(data.length / 4)).fill(null)
      data.map((ele, idx) => {
        tagRow[Math.floor(idx / 4)] ? tagRow[Math.floor(idx / 4)].push(ele) : (tagRow[Math.floor(idx / 4)] = [ele])
      })
      this.tagRow = tagRow
      this.rowFlag = new Array(tagRow.length).fill(false)
    },
    openRow(rowIdx, idx, item) {
      this.currentRowIdx = rowIdx
      this.currentItemIdx = idx
      this.getDetail(item)
      this.$forceUpdate()
    },
    closeRow() {
      this.currentRowIdx = -1
      this.currentItemIdx = -1
      this.$forceUpdate()
    },
    tagType(name) {
      return this.selectedFunction.some(val => name === val.名称) ? 'dark' : 'plain'
    },
    subTagType(name, type) {
      const fun = this.currentDetailData.名称
      const flag =
        this.selectedFunction.some(val => fun === val.名称) &&
        this.selectedFunction.find(val => val.名称 === fun)[type] &&
        this.selectedFunction.find(val => val.名称 === fun)[type].some(val => val === name)
      return flag ? 'dark' : 'plain'
    },
    hasIndustries(industries) {
      if (industries === '通用') {
        return functionData
          .find(val => val.行业 === industries)
          .children.some(val => this.selectedFunction.some(innerval => val === innerval.名称))
      } else {
        return functionData
          .find(val => val.行业 === industries)
          .children.some(val =>
            this.selectedFunction
              .filter(innerval =>
                functionData
                  .find(val => val.行业 === '通用')
                  .children.every(ininnerval => innerval.名称 !== ininnerval),
              )
              .some(innerval => val === innerval.名称),
          )
      }
    },
    open() {
      this.dialogVisible = true
    },
    selectFunction(rowIdx, idx, item) {
      if (this.selectedFunction.some(val => item === val.名称)) {
        rowIdx === this.currentRowIdx && item === this.currentDetailData.名称
          ? this.closeRow()
          : this.openRow(rowIdx, idx, item)
      } else {
        this.single ? (this.selectedFunction = [{ 名称: item }]) : this.selectedFunction.push({ 名称: item })
        this.openRow(rowIdx, idx, item)
      }
    },
    selectSub(item, type) {
      const fun = this.currentDetailData.名称
      if (this.selectedFunction.every(val => fun != val.名称)) {
        this.single ? (this.selectedFunction = [{ 名称: fun }]) : this.selectedFunction.push({ 名称: fun })
      }
      this.selectedFunction.map(ele => {
        if (ele.名称 === fun) {
          if (ele[type] && ele[type].some(val => item === val)) {
            ele[type] = ele[type].filter(val => item !== val)
          } else {
            ele[type] ? ele[type].push(item) : (ele[type] = [item])
          }
        }
      })
      this.$forceUpdate()
    },
    removeFunction(item, rowIdx, idx) {
      this.selectedFunction = this.selectedFunction.filter(val => item !== val.名称)
      this.currentDetailData.名称 === item && this.closeRow()
    },
    removeSub(item, type) {
      const fun = this.currentDetailData.名称
      console.log(this.selectedFunction)
      this.selectedFunction.map(ele => {
        if (ele.名称 === fun) {
          console.log(ele, type)
          ele[type] = ele[type].filter(val => item !== val)
        }
      })
      this.$forceUpdate()
    },
    querySearch: async function(queryString, cb) {
      const list = this.allFunctionData
      const results = queryString != null ? list.filter(this.createFilter(queryString)) : list
      return cb(results)
    },
    createFilter: function(queryString) {
      return func => func.match(new RegExp(queryString, 'i'))
    },
    loadAllFunction: async function() {
      if (!app.categories) await app.getCats()
      this.allFunctionData = app.categories.map(cate => cate['名称'])
    },
    submitData() {
      const submitData = this.selectedFunction
      if (submitData.length === 0) {
        this.$message({
          message: '请选择至少一个职能模块',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', submitData)
      this.dialogVisible = false
      this.selectedFunction = []
      this.init()
    },
    cancel() {
      this.dialogVisible = false
      this.selectedFunction = []
      this.init()
    },
    getDetail(item) {
      const cateData = app.categories
      this.currentDetailData.细分职能 = cateData.find(ele => ele.名称 === item)['二级职能'] || []
      this.currentDetailData.擅长方向 = cateData.find(ele => ele.名称 === item)['擅长方向'] || []
      this.currentDetailData.名称 = item
    },
  },
}
</script>
<style scoped src="../../statistics/css/hunting.css"></style>
<style scoped>
.custom-dialog {
  margin-top: 8vh !important;
}
.custom-dialog .el-dialog__body {
  padding-top: 15px;
  padding-bottom: 0;
}
.cus-autoc .el-input {
  font-size: 14px !important;
}
.custom-tags {
  color: #303133;
}
.custom-tags.el-tag--dark {
  color: #fff;
}
.custom-tags.el-tag--dark:hover {
  color: #fff;
}
.custom-tags:hover {
  color: #409eff;
}
.tag-item:hover > i {
  color: #409eff !important;
}
</style>
<style scoped>
.custom-dialog .el-dialog__body {
  padding-top: 15px;
}
</style>
